import { render, staticRenderFns } from "./productCategory.vue?vue&type=template&id=5a1066f4&scoped=true"
import script from "./productCategory.vue?vue&type=script&lang=js"
export * from "./productCategory.vue?vue&type=script&lang=js"
import style0 from "./productCategory.vue?vue&type=style&index=0&id=5a1066f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1066f4",
  null
  
)

export default component.exports